export default __webpack_public_path__ + "static/media/nbt.0d19da61.jsworker";